/* eslint-disable @typescript-eslint/no-empty-interface */
import { PlatformPlan } from 'TypeDefs/Checkout'
import { analytics } from 'Modules/Analytics'
import { StoryVariants } from 'Components/Pages/Impact/ImpactStories/ImpactStoriesPage/StoryAiDialog/StoryAiTypes'

const config = { domain: 'Impact', subdomain: 'Stories' }

interface StoryTemplateClicked {
  templateName: string
}

interface StoryId {
  storyId: number
}

interface ShareParams {
  storyId: number
  platformName: string
}

interface ContentSaveClicked {
  storyId: number
  assetType: string
}

interface DownloadPDFClicked {
  hashedStoryId: number
}

interface EmptyParams {}

interface GuideCourseClicked {
  courseId: string
  courseTitle: string
}

interface GuideResourceClicked {
  resourceId: string
  resourceName: string
}
interface NavigationToolTip {
  tipId: string
}

interface DonationsParams {
  orgId: number
  userId: number
}

interface BlockBackgroundColorChanged {
  orgId: number
  userId: number
  platformPlan: PlatformPlan | null
  funderOrgId: number
  hexColor: string
  assetType: string
  storyId: number | string
}

interface EventParamsWithAssetType {
  orgId: number
  userId: number
  platformPlan: PlatformPlan | null
  funderOrgId: number
  storyId: number | string
  assetType: string
}

interface BlockSpecificEventParams {
  orgId: number
  userId: number
  platformPlan: PlatformPlan | null
  funderOrgId: number
  storyId: number | string
}

interface PublishSubmittedParams {
  storyId: StoryId
  storyTitle: string
  storyDatePublished: string
  storyStatus: boolean
}

interface AiCreateStorySubmitted {
  userId: number
  nonprofitOrgId: number
  goalId: number | null
  platformPlan: PlatformPlan | null
  funderOrgId: number
  email: string
  role: string
  relationship: string
  storyVariant: StoryVariants
  dateCreated: string
}

interface AiCreateDraftInput {
  email: string
  funderOrgId: number
  nonprofitOrgId: number
  platformPlan: PlatformPlan | null
  userId: number
  goalId?: number | null
  role: string
  relationship: string
  storyVariant: StoryVariants
}

interface BlockUpdated {
  assetType: string
  email: string
  funderOrgId: number | null
  nonprofitOrgId: number
  platformPlan: PlatformPlan | null
  storyId: number
  userId: number
  role: string
  relationship: string
  storyUpdated: string
}

interface AiPurposeSelected extends AiCreateDraftInput {
  purposeSelected?: string
}

interface AiAudienceSelected extends AiCreateDraftInput {
  audienceSelected?: string
}

export interface sharedStoryInput {
  email: string
  funderOrgId: number | null
  nonprofitOrgId: number
  platformPlan: PlatformPlan | null
  storyId?: number | string
  userId: number
  role: string
  relationship: string
}

interface SettingsClicked extends sharedStoryInput {}
interface SettingsColorClicked extends sharedStoryInput {}
interface SettingsEditLogoClicked extends sharedStoryInput {}
interface SettingsTableOfContentsClicked extends sharedStoryInput {
  tableOfContents: 'ON' | 'OFF'
}
interface SettingsTitlePreviewClicked extends sharedStoryInput {}
interface SettingsDescriptionPreviewClicked extends sharedStoryInput {}
interface CopyPublicLinkClicked extends sharedStoryInput {}
interface EditStoryBuilderClicked extends sharedStoryInput {}

export const stories = {
  Clicked: {
    Clicked: (param: EmptyParams) => param,
    config,
  },
  Create_Story_Clicked: {
    Create_Story_Clicked: (param: EmptyParams) => param,
    config,
  },
  Template_Clicked: {
    Template_Clicked: (param: StoryTemplateClicked) => param,
    config,
  },
  Save_Clicked: {
    Save_Clicked: (param: StoryId) => param,
    config,
  },
  Publish_Clicked: {
    Publish_Clicked: (param: StoryId) => param,
    config,
  },
  Publish_Submitted: {
    Publish_Submitted: (param: PublishSubmittedParams) => param,
    config,
  },
  Preview_Dialog_Publish_Clicked: {
    Preview_Dialog_Publish_Clicked: (param: StoryId) => param,
    config,
  },
  Preview_Dialog_Cancel_Clicked: {
    Preview_Dialog_Cancel_Clicked: (param: StoryId) => param,
    config,
  },
  Share_To_Email_Clicked: {
    Share_To_Email_Clicked: (param: ShareParams) => param,
    config,
  },
  Share_To_LinkedIn_Clicked: {
    Share_To_LinkedIn_Clicked: (param: ShareParams) => param,
    config,
  },
  Share_To_Facebook_Clicked: {
    Share_To_Facebook_Clicked: (param: ShareParams) => param,
    config,
  },
  Share_To_Twitter_Clicked: {
    Share_To_Twitter_Clicked: (param: ShareParams) => param,
    config,
  },
  Share_Story_CTA_Clicked: {
    Share_Story_CTA_Clicked: (param: StoryId) => param,
    config,
  },
  Archive_Clicked: {
    Archive_Clicked: (param: StoryId) => param,
    config,
  },
  Archive_Cancel_Clicked: {
    Archive_Cancel_Clicked: (param: StoryId) => param,
    config,
  },
  Archive_Submitted: {
    Archive_Submitted: (param: StoryId) => param,
    config,
  },
  Unpublish_Clicked: {
    Unpublish_Clicked: (param: StoryId) => param,
    config,
  },
  Unpublish_Cancel_Clicked: {
    Unpublish_Cancel_Clicked: (param: StoryId) => param,
    config,
  },
  Unpublish_Submitted: {
    Unpublish_Submitted: (param: StoryId) => param,
    config,
  },
  Edit_Published_Story_Clicked: {
    Edit_Published_Story_Clicked: (param: StoryId) => param,
    config,
  },
  Duplicate_Story_Clicked: {
    Duplicate_Story_Clicked: (param: StoryId) => param,
    config,
  },
  Discard_Changes_Clicked: {
    Discard_Changes_Clicked: (param: StoryId) => param,
    config,
  },
  Content_Save_Clicked: {
    Content_Save_Clicked: (param: ContentSaveClicked) => param,
    config,
  },
  Guide_Viewed: {
    Guide_Viewed: (param: EmptyParams) => param,
    config,
  },
  Dismiss_Guide_Clicked: {
    Dismiss_Guide_Clicked: (param: EmptyParams) => param,
    config,
  },
  Hide_Mobile_Guide_Clicked: {
    Hide_Mobile_Guide_Clicked: (param: EmptyParams) => param,
    config,
  },
  Recall_Guide_Clicked: {
    Recall_Guide_Clicked: (param: EmptyParams) => param,
    config,
  },
  Expand_Guide_Clicked: {
    Expand_Guide_Clicked: (param: EmptyParams) => param,
    config,
  },
  Minimize_Guide_Clicked: {
    Minimize_Guide_Clicked: (param: EmptyParams) => param,
    config,
  },
  Guide_Course_Clicked: {
    Guide_Course_Clicked: (param: GuideCourseClicked) => param,
    config,
  },
  Guide_Resource_Clicked: {
    Guide_Resource_Clicked: (param: GuideResourceClicked) => param,
    config,
  },
  Tip_Viewed: {
    Tip_Viewed: (param: NavigationToolTip) => param,
    config,
  },
  Acknowledge_Tip_Clicked: {
    Acknowledge_Tip_Clicked: (param: NavigationToolTip) => param,
    config,
  },
  Celebration_Viewed: {
    Celebration_Viewed: (param: NavigationToolTip) => param,
    config,
  },
  Edit_Donation_Portal_Clicked: {
    Edit_Donation_Portal_Clicked: (param: DonationsParams) => param,
    config,
  },
  Donations_ResumeSetup_Clicked: {
    Donations_ResumeSetup_Clicked: (param: DonationsParams) => param,
    config,
  },
  Add_Block_Clicked: {
    Add_Block_Clicked: (param: EventParamsWithAssetType) => param,
    config,
  },
  Delete_Block_Clicked: {
    Delete_Block_Clicked: (param: EventParamsWithAssetType) => param,
    config,
  },
  Block_Background_Color_Changed: {
    Block_Background_Color_Changed: (param: BlockBackgroundColorChanged) =>
      param,
    config,
  },
  Image_And_Text_Block_Layout_Clicked: {
    Image_And_Text_Block_Layout_Clicked: (param: BlockSpecificEventParams) =>
      param,
    config,
  },
  Summary_Metric_Delete_Clicked: {
    Summary_Metric_Delete_Clicked: (param: BlockSpecificEventParams) => param,
    config,
  },
  Summary_Metric_Add_Clicked: {
    Summary_Metric_Add_Clicked: (param: BlockSpecificEventParams) => param,
    config,
  },
  Download_PDF_Clicked: {
    Download_PDF_Clicked: (param: DownloadPDFClicked) => param,
    config,
  },
  Text_Block_Edit_Intent_Clicked: {
    Text_Block_Edit_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Text_Block_Edit_Finished_Clicked: {
    Text_Block_Edit_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Block_Drag_Drop_Clicked: {
    Block_Drag_Drop_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Quote_Block_Edit_Intent_Clicked: {
    Quote_Block_Edit_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Quote_Block_Edit_Finished_Clicked: {
    Quote_Block_Edit_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Metrics_Block_Edit_Intent_Clicked: {
    Metrics_Block_Edit_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Metrics_Block_Edit_Finished_Clicked: {
    Metrics_Block_Edit_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  TextImage_Block_Edit_Text_Intent_Clicked: {
    TextImage_Block_Edit_Text_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  TextImage_Block_Edit_Text_Finished_Clicked: {
    TextImage_Block_Edit_Text_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  TextImage_Block_Edit_Add_Picture_Clicked: {
    TextImage_Block_Edit_Add_Picture_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Image_Block_Edit_Add_Picture_Clicked: {
    Image_Block_Edit_Add_Picture_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Upload_Picture_Clicked: {
    Upload_Picture_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Confirm_Picture_Clicked: {
    Confirm_Picture_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Select_Picture_Submitted: {
    Select_Picture_Submitted: (param: BlockUpdated) => param,
    config,
  },
  Video_Block_Edit_Intent_Clicked: {
    Video_Block_Edit_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Video_Block_Edit_Finished_Clicked: {
    Video_Block_Edit_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  CTA_Block_Edit_Intent_Clicked: {
    CTA_Block_Edit_Intent_Clicked: (param: BlockUpdated) => param,
    config,
  },
  CTA_Block_Edit_Finished_Clicked: {
    CTA_Block_Edit_Finished_Clicked: (param: BlockUpdated) => param,
    config,
  },
  Ai_Create_Story_Clicked: analytics.trackCreator<AiCreateStorySubmitted>({
    ...config,
    eventName: 'Ai_Create_Story_Clicked',
  }),
  Ai_Purpose_Selected: analytics.trackCreator<AiPurposeSelected>({
    ...config,
    eventName: 'Ai_Purpose_Selected',
  }),
  Ai_Goal_Selected: analytics.trackCreator<AiCreateDraftInput>({
    ...config,
    eventName: 'Ai_Goal_Selected',
  }),
  Ai_Audience_Selected: analytics.trackCreator<AiAudienceSelected>({
    ...config,
    eventName: 'Ai_Audience_Selected',
  }),
  Ai_Impact_Selected: analytics.trackCreator<AiCreateDraftInput>({
    ...config,
    eventName: 'Ai_Impact_Selected',
  }),
  Ai_Importance_Selected: analytics.trackCreator<AiCreateDraftInput>({
    ...config,
    eventName: 'Ai_Importance_Selected',
  }),
  Ai_Additionalrequests_Selected: analytics.trackCreator<AiCreateDraftInput>({
    ...config,
    eventName: 'Ai_Additionalrequests_Selected',
  }),
  Ai_Goal_Progress_Clicked: analytics.trackCreator<AiCreateDraftInput>({
    ...config,
    eventName: 'Ai_Goal_Progress_Clicked',
  }),
  Settings_Clicked: analytics.trackCreator<SettingsClicked>({
    ...config,
    eventName: 'Settings_Clicked',
  }),
  Settings_Color_Clicked: analytics.trackCreator<SettingsColorClicked>({
    ...config,
    eventName: 'Settings_Color_Clicked',
  }),
  Settings_EditLogo_Clicked: analytics.trackCreator<SettingsEditLogoClicked>({
    ...config,
    eventName: 'Settings_EditLogo_Clicked',
  }),
  Settings_TableOfContents_Clicked:
    analytics.trackCreator<SettingsTableOfContentsClicked>({
      ...config,
      eventName: 'Settings_TableOfContents_Clicked',
    }),
  Settings_TitlePreview_Clicked:
    analytics.trackCreator<SettingsTitlePreviewClicked>({
      ...config,
      eventName: 'Settings_TitlePreview_Clicked',
    }),
  Settings_DescriptionPreview_Clicked:
    analytics.trackCreator<SettingsDescriptionPreviewClicked>({
      ...config,
      eventName: 'Settings_DescriptionPreview_Clicked',
    }),
  Copy_Public_Link_Clicked: analytics.trackCreator<CopyPublicLinkClicked>({
    ...config,
    eventName: 'Copy_Public_Link_Clicked',
  }),
  Edit_StoryBuilder_Clicked: analytics.trackCreator<EditStoryBuilderClicked>({
    ...config,
    eventName: 'Edit_StoryBuilder_Clicked',
  }),
}
